import { createElement } from 'react';
import {
  ILabel,
  IRenderContext,
  LabelStyleBase,
  Size,
  SvgVisual,
  Visual,
} from '@ardoq/yfiles';
import { createSvgElement } from '@ardoq/dom-utils';
import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { fontFamily } from '@ardoq/design-tokens';
import { logError } from '@ardoq/logging';
import { Root } from 'react-dom/client';
import { DiffType } from '@ardoq/data-model';
import { ensureRoot, initializeRoot } from '../reactRootsRegistry';
import { disposeCallback } from '../disposeCallback';
import { CountLabel } from '../visuals/CountLabel';
import { AGGREGATED_COUNT_LABEL_SIZE } from '../visuals/consts';
import { isAggregatedGraphEdge } from '../graphItems/predicates';

const SVG_BODY_FONT = `normal 14px/normal ${fontFamily.regular}`;
const measureSvgLabel = canvasLabelMeasurer(SVG_BODY_FONT);

export class AggregatedEdgeLabelStyle extends LabelStyleBase {
  constructor(
    private getCssClassFromDiffType?: (diffType: DiffType | undefined) => string
  ) {
    super();
  }

  createVisual(context: IRenderContext, label: ILabel) {
    const g = createSvgElement('g');
    this.render(initializeRoot(g), g, label);

    SvgVisual.setTranslate(
      g,
      label.layout.bounds.centerX,
      label.layout.bounds.centerY
    );
    const result = new SvgVisual(g);
    context.setDisposeCallback(result, disposeCallback);
    return result;
  }
  updateVisual(_context: IRenderContext, oldVisual: Visual, label: ILabel) {
    if (
      !(
        oldVisual instanceof SvgVisual &&
        oldVisual.svgElement instanceof SVGGElement
      )
    ) {
      logError(Error('Unrecognized visual.'));
      return oldVisual;
    }
    const container = oldVisual.svgElement;
    this.render(ensureRoot(container), container, label);
    SvgVisual.setTranslate(
      container,
      label.layout.bounds.centerX,
      label.layout.bounds.centerY
    );
    return oldVisual;
  }
  render(root: Root, container: SVGGElement, label: ILabel) {
    container.setAttribute('class', 'integration');
    const graphEdge = isAggregatedGraphEdge(label.tag) ? label.tag : null;
    if (Array.isArray(graphEdge?.modelIds)) {
      container.dataset.referenceModelIds = graphEdge?.modelIds.join(',');
    }

    if (!label.text) {
      return;
    }
    root.render(
      createElement(CountLabel, {
        count: Number(label.text),
        diffCSSClass: this.getCssClassFromDiffType?.(
          graphEdge?.getVisualDiffType()
        ),
      })
    );
  }
  override getPreferredSize(label: ILabel) {
    return new Size(measureSvgLabel(label.text), AGGREGATED_COUNT_LABEL_SIZE);
  }
}
